import { siteUrl } from "./getSiteUrl";

// TODO: Remove Preferences
const pageType: Record<string, string> = {
  blog: "Blog",
  dev: "Dev Tests",
  "": "Home",
  "/": "Home",
  home: "Home",
  "join-beauty-pie": "Join",
  "bp/join/join-beauty-pie": "Join",
  login: "Login",
  shop: "PLP",
  products: "PDP",
  register: "Register",
  "refer-a-friend": "Refer A Friend",
  "reset-password": "Reset Password",
  "forgot-password": "Forgot Password",
  "shop/search": "Search Results",
  "order-history": "Order History",
  "account/order-history": "Order History",
  "beauty-pie-upgrade": "Upgrade",
  basket: "Basket",
  "virtual-consultations": "Virtual Consultations",
  "account/wishlist": "Wishlist",
  "account/profile": "Profile",
  "account/favourites/order-it-again": "Order It Again",
  "account/favourites/for-you": "Just For You",
  "account/refer-a-friend": "Refer A Friend",
  "account/member-benefits": "Member Benefits",
  "legal/privacy-policy": "Privacy Policy",
  "legal/applicant-privacy-policy": "Privacy Policy",
  "legal/business-contact-privacy-notice": "Privacy Policy",
  "legal/cookie-policy": "Cookie Policy",
  "legal/terms-and-conditions": "Terms and Conditions",
  "legal/promo-terms": "Terms and Conditions",
  "legal/modern-slavery-statement": "Modern Slavery Statement",
  "beauty-pie-reviews": "Reviews",
  "gift-memberships": "Gift Memberships",
  careers: "Careers",
  waitlist: "Waitlist",
  paystate: "Payment State",
  logout: "Logout",
  "confirmed/unsubscribed": "Email Unsubscribed",
  "confirmed/feedback-confirmed": "Feedback Confirmation",
  about: "About",
  campaign: "Campaign",
  "esg-statement": "ESG Statement",
  checkout: "Review and Pay",
  "checkout/success": "Order Confirmation",
  "guest-details": "Guest Checkout",
  "quiz/skincare": "Quiz",
  "redeem-referral": "Redeem Referral",
  signin: "Sign In v2",
  "signin/register": "Sign In Register v2",
  "signin/password": "Sign In Log In v2"
};

const nestedDynamicPages: Record<string, string> = {
  "order-history": "Order Detail"
};

export const pathnameToPageType = (asPath: string, locale = "us"): string => {
  const path = new URL(`${siteUrl}${asPath}`).pathname;
  const localePath = `/${locale.toLowerCase()}`;

  // Handle root paths for locale ("/" and "/us")
  if (path === "/" || path === localePath || path === `${localePath}/`) {
    return "Home";
  }

  // Remove the locale prefix from the path
  const trimmedPath = path.startsWith(`${localePath}/`)
    ? path.substring(localePath.length)
    : path;

  const paths = trimmedPath.split("/").filter(Boolean);

  // Handle dynamic pages
  if (paths.length > 1 && paths[paths.length - 1] === "[id]") {
    return nestedDynamicPages[paths[paths.length - 2]] ?? "Unknown Page";
  }

  // Match the longer paths first
  for (let i = paths.length; i > 0; i--) {
    const key = paths.slice(0, i).join("/");
    if (pageType[key]) return pageType[key];
  }

  return pageType[paths[0]] ?? "Unknown Page";
};
